import Rest from '../Rest'

export default class CampaignParticipationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/participations'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  approve(id: number) {
    return this.put(`/${id}/approve`, {})
  }

  reject(id: number, reason: string) {
    return this.put(`/${id}/reject`, { reason })
  }

  pause(id: number, reason: string) {
    return this.put(`/${id}/pause`, { reason })
  }

  block(id: number, reason: string) {
    return this.put(`/${id}/block`, { reason })
  }
}
